<div class="files-management" [class.has-selection]="checkedLeads.length">
  <div class="normal-actions">
    @if (leadCreateAction) {
      <button type="button" class="action-btn primary" (click)="newRequest()">
        <img class="prefix-icon" src="/assets/icons/new/plus-light.svg" alt="File add"
          matTooltip="{{leadCreateAction.Text}}" matTooltipPosition="below" matTooltipClass="tooltip-style">
        <span>{{ leadCreateAction.Text }}</span>
      </button>
    }

    <button type="button" class="action-btn secondary" (click)="openCreateRequestFromComposerDialog()">
      <img class="prefix-icon" #composer [isTitle]="true" matTooltip="{{composer.dataset.matTooltip}}"
        fiTranslation="BUTTON_NEW_COMPOSER_LEAD"
        matTooltipPosition="below" matTooltipClass='tooltip-style' src="/assets/icons/new/composer.svg"
        alt="composer-icon">
      <span fiTranslation="BUTTON_NEW_COMPOSER_LEAD"></span>
    </button>

    <button type="button" class="icon-btn download" (click)="downloadRequest()">
      @if (!downloadIsInProgress) {
        <img #download [isTitle]="true" matTooltip="{{download.dataset.matTooltip}}"
          fiTranslation="BUTTON_DOWNLOAD_LIST"
          matTooltipPosition="below" matTooltipClass='tooltip-style' src="/assets/icons/new/download.svg"
          alt="download-icon"
          >
      }
      @if (downloadIsInProgress) {
        <mat-spinner class="loader" [diameter]="20"></mat-spinner>
      }
    </button>
  </div>

  @if (checkedLeads.length) {
    <div class="selected-actions">
      @if (leadProcessAction) {
        <button class="action-btn primary" type="button"
          (click)="doAction(leadProcessAction)" [disabled]="!leadProcess">
          <img class="prefix-icon" [src]="actionHelper.getActionIconUrl('LEAD_PROCESS', false)" alt="action-icon"
            matTooltip="{{leadProcessAction.Text}}" matTooltipPosition="below" matTooltipClass="tooltip-style">
          <span>{{ leadProcessAction.Text }} ({{ checkedLeads.length }})</span>
        </button>
      }
      <button #additionalAction type="button" class="action-btn secondary more-actions"
        (click)="openAdditionalActions = !openAdditionalActions">
        <span fiTranslation="ALT_TEXT_REQUEST_ADDITIONAL_ACTIONS"></span>
        <img class="arrow" [class.open]="openAdditionalActions" src="/assets/icons/arrow-up.svg" alt="Arrow">
      </button>
      <div #menu class="more-actions-menu" [class.show]="openAdditionalActions">
        @if (leadAssignEnquiryAction) {
          <button type="button" (click)="doAction(leadAssignEnquiryAction)"
            [disabled]="!leadAssignEnquiry">
            <img class="prefix-icon" [src]="actionHelper.getActionIconUrl('LEAD_FORWARD', false)" alt="action-icon">
            <span>{{ leadAssignEnquiryAction.Text }} ({{ checkedLeads.length }})</span>
          </button>
        }
        @if (leadTypeAction) {
          <button type="button" (click)="doAction(leadTypeAction)" [disabled]="!leadType">
            <img class="prefix-icon" [src]="actionHelper.getActionIconUrl('LEAD_TYPE', false)" alt="action-icon">
            <span>{{ leadTypeAction.Text }} ({{ checkedLeads.length }})</span>
          </button>
        }
        @if (leadNotInterestedAction) {
          <button type="button" (click)="doAction(leadNotInterestedAction)"
            [disabled]="!leadNotInterested">
            <img class="prefix-icon" [src]="actionHelper.getActionIconUrl('LEAD_NOT_INTERESTED', false)" alt="action-icon">
            <span>{{ leadNotInterestedAction.Text }} ({{ checkedLeads.length }})</span>
          </button>
        }
        @if (appointmentReminderAction) {
          <button type="button" (click)="doAction(appointmentReminderAction)"
            [disabled]="!appointmentReminder">
            <img class="prefix-icon" [src]="actionHelper.getActionIconUrl('LEAD_REMINDER', false)" alt="action-icon">
            <span>{{ appointmentReminderAction.Text }} ({{ checkedLeads.length }})</span>
          </button>
        }
        @if (markAsReadEnabled || markAsUnReadEnabled) {
          <button type="button" (click)="markAsReadEnabled ? markAsRead() : markAsUnRead()"
            >
            <img class="prefix-icon" src="/assets/icons/new/eye.svg"
              alt="{{markAsReadEnabled ? 'REQUEST_OVERVIEW_BULK_MARK_AS_READ' : 'REQUEST_OVERVIEW_DETAIL_UNREAD'}}">
            <span>
              @if (markAsReadEnabled) {
                <span fiTranslation="REQUEST_OVERVIEW_BULK_MARK_AS_READ"></span>
              }
              @if (markAsUnReadEnabled) {
                <span fiTranslation="REQUEST_OVERVIEW_DETAIL_UNREAD"></span>
              }
              ({{ checkedLeads.length }})
            </span>
          </button>
        }
      </div>
    </div>
  }
</div>
